import { MediBlogArticle, MediBlogCategory } from '../services/mediBlog';

type LocalizedField = 'title' | 'excerpt' | 'content' | 'name';

const fieldMap: Record<LocalizedField, Record<string, keyof MediBlogArticle | keyof MediBlogCategory>> = {
  title: { en: 'title_en', ar: 'title_ar', fr: 'title_fr' },
  excerpt: { en: 'excerpt_en', ar: 'excerpt_ar', fr: 'excerpt_fr' },
  content: { en: 'content_en', ar: 'content_ar', fr: 'content_fr' },
  name: { en: 'name_en', ar: 'name_ar', fr: 'name_fr' },
};

export function getLocalizedArticleField(
  article: MediBlogArticle,
  field: 'title' | 'excerpt' | 'content',
  language: string
): string {
  const lang = language.startsWith('ar') ? 'ar' : language.startsWith('fr') ? 'fr' : 'en';
  const key = fieldMap[field][lang] as keyof MediBlogArticle;
  const fallback = fieldMap[field].en as keyof MediBlogArticle;
  const value = article[key] ?? article[fallback];
  return typeof value === 'string' ? value : '';
}

export function getLocalizedCategoryName(category: MediBlogCategory, language: string): string {
  const lang = language.startsWith('ar') ? 'ar' : language.startsWith('fr') ? 'fr' : 'en';
  const key = fieldMap.name[lang] as keyof MediBlogCategory;
  const fallback = fieldMap.name.en as keyof MediBlogCategory;
  const value = category[key] ?? category[fallback];
  return typeof value === 'string' ? value : '';
}
